import Vue from 'vue';
import pub from '@/mixins/global/pub';
import wxMixins from '@/mixins/global/wxMixins';

function initGlobalMixins() {
    Vue.mixin(pub);
    Vue.mixin(wxMixins);
}
initGlobalMixins();
